import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useUser } from '../contexts/UserContext';

const ProtectedRoute = ({ children, requireSubscription = false }) => {
  const { user, userSubscription, loading } = useUser();
  const location = useLocation();

  if (loading) {
    return (
      <div className="h-screen bg-gray-900 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-green-500 mx-auto mb-4"></div>
          <p className="text-green-500 font-bold">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Don't redirect if already on select-plan page
  if (location.pathname === '/select-plan') {
    return children;
  }

  // Check if user has an active subscription (including free Semi Pro plan)
  const hasActiveSubscription = userSubscription && (
    userSubscription.subscriptionStatus === 'active' ||
    userSubscription.subscriptionPlan === 'basic'
  );

  // Only redirect to plan selection if requireSubscription is true AND user doesn't have active subscription
  if (requireSubscription && !hasActiveSubscription) {
    return <Navigate to="/select-plan" replace />;
  }

  return children;
};

export default ProtectedRoute;

